import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const SearchBar = ({ searchQuery, onSearchChange, onSearchSubmit }) => {
  const [localQuery, setLocalQuery] = useState(searchQuery);

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSearchSubmit(localQuery);
  };

  const handleClear = () => {
    setLocalQuery('');
    onSearchChange('');
  };

  return (
    <form onSubmit={handleSubmit} className="relative flex-1 max-w-md">
      <div className="relative">
        <Input
          type="search"
          placeholder="Search shoes, clothes, bags..."
          value={localQuery}
          onChange={(e) => {
            setLocalQuery(e?.target?.value);
            onSearchChange(e?.target?.value);
          }}
          className="pl-10 pr-10"
        />
        
        <Icon
          name="Search"
          size={16}
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
        />
        
        {localQuery && (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={handleClear}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 h-6 w-6"
          >
            <Icon name="X" size={14} />
          </Button>
        )}
      </div>
    </form>
  );
};

export default SearchBar;